<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="eui-message-box eui-message-box--{{ type }} eui-u-anim eui-u-anim--flipInY" role="dialog" tabIndex="-1" attr.data-e2e="{{ e2eAttr }}">
    <div class="eui-message-box__wrapper" role="document">
        <div class="eui-message-box__content">
            <div class="eui-message-box__header">
                <h5 class="eui-message-box__header-title">{{ title }}</h5>
                <button *ngIf="hasCloseButton" (click)="closeMessageBox()" euiButton euiIconButton euiSizeM euiBasicButton>
                    <span class="eui-icon eui-icon-close-m"></span>
                </button>
            </div>
            <div class="eui-message-box__body">
                <div class="eui-message-box__body-icon">
                    <span euiIcon iconClass="eui-icon eui-icon-ecl-error eui-message-box__body-icon-content" *ngIf="type === 'danger'"></span>
                    <span euiIcon iconClass="eui-icon eui-icon-check eui-message-box__body-icon-content" *ngIf="type === 'success'"></span>
                    <span euiIcon iconClass="eui-icon eui-icon-info eui-message-box__body-icon-content" *ngIf="type === 'info'"></span>
                    <span euiIcon iconClass="eui-icon eui-icon-question eui-message-box__body-icon-content" *ngIf="type === 'question'"></span>
                    <span euiIcon iconClass="eui-icon eui-icon-exclamation-triangle eui-message-box__body-icon-content" *ngIf="type === 'warning'"></span>
                </div>
                <div class="eui-message-box__body-content" *ngIf="!isContentTemplatePortal" [innerHTML]="content ? content : null"></div>
                <div class="eui-message-box__body-content" *ngIf="isContentTemplatePortal">
                    <ng-template [cdkPortalOutlet]="content"></ng-template>
                </div>
            </div>
            <div class="eui-message-box__footer">
                <ng-container *ngIf="isFooterTemplatePortal">
                    <ng-template [cdkPortalOutlet]="footer"></ng-template>
                </ng-container>
                <ng-container *ngIf="!isFooterTemplatePortal">
                    <button #focusedButton class="eui-message-box__footer-dismiss-button" (click)="onDismiss()" euiButton>{{ dismissLabel | translate }}</button>
                    <button class="eui-message-box__footer-accept-button" (click)="onAccept()" euiButton euiPrimary>{{ acceptLabel | translate }}</button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
